import DriverList from '@/controllers/driver/driver-list.js';

export default {
  extends: DriverList,
}
